<template>
    <div class="t-items items">
        <slot name="header" />
        <slot name="main" />
        <div 
            v-if="isIconDown"
            class="items__icon-container"
        >
            <svg-icon
                original
                name="icons/arrow-down"
                class="items__icon"
            />
        </div>
        <div 
            v-if="isFooter"
            class="items__footer"
        >
            <AMBackButton
                :text="footerButtonText"
                :theme="footerButton"
                @onClick="handleClick"
            />
        </div>
        <MIndexPanel
            v-if="indexPanel"
            :value="currentLetterIndexPanel"
            :active-buttons="activeButtons"
            @clickLetter="handleClickLetter"
        />
    </div>
</template>

<script>
import MIndexPanel from '../../molecules/m-index-panel/m-index-panel';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
    
export default {
    name: 'TItems',
    components: {
        MIndexPanel,
        AMBackButton
    },
    data() {
        return {
            currentLetterIndex: 'a'
        }
    },
    props: {
        footerButton: {
            type: String,
            default: 'close'
        },
        footerButtonText: {
            type: String,
            default: ''
        },
        activeButtons: {
            type: Array,
            default: () => []
        },
        indexPanel: {
            type: Boolean,
            default: false
        },
        currentLetterIndexPanel: {
            type: String,
            default: ''
        },
        isFooter: {
            type: Boolean,
            default: true
        },
        isIconDown: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        handleClick() {
            this.$emit('clickFooterButton', true);
        },
        handleClickLetter(evt) {
            this.$emit('clickLetter', evt);
        }
    }
}
</script>

<style lang="scss">
@import "t-items";
</style>